/* eslint-disable
    react/prefer-stateless-function
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
import PropTypes from 'prop-types';
import React from 'react';

import SortableTable from 'ui-library/SortableTable';
import {capitalize, constantCaseToWords} from 'util/NameUtil';

const {defaultColumn} = SortableTable;

class UserOpenReviews extends React.Component {
  static propTypes = {
    openReviews: PropTypes.arrayOf(
      PropTypes.shape({
        entryName: PropTypes.string.isRequired,
        status: PropTypes.string.isRequired,
        role: PropTypes.oneOf(['Auditor', 'Author']),
      })
    ).isRequired,
  };

  render() {
    const columns = [
      defaultColumn('Entry Name', 'entryName'),
      defaultColumn('Status', 'status', {
        transform(value) {
          return capitalize(constantCaseToWords(value));
        },
      }),
      defaultColumn('Role', 'role'),
    ];
    const rows = this.props.openReviews;
    return (
      <div>
        <h4>{`Open Reviews (${rows.length})`}</h4>
        <SortableTable columns={columns} rows={rows} />
      </div>
    );
  }
}

export default UserOpenReviews;
